import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=5fdaec32&scoped=true&"
var script = {}
import style0 from "./Top.vue?vue&type=style&index=0&id=5fdaec32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdaec32",
  null
  
)

export default component.exports